import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';
import theaterSVG from '../../ui/icons/theater.svg';
import {
    THEATER_MODE_EVENT,
    THEATER_MODE_ATTRIBUTE
} from '../../constants';

const Button = VideoJS.getComponent('Button');

class ASTheaterToggle extends Button {
    constructor(player, options) {
        super(player, options);
        this.on(player, [THEATER_MODE_EVENT], this.update);
    }

    createEl(tag, props, attrs) {
        const el =  super.createEl(tag, props, attrs);

        el.appendChild(VideoJS.dom.createEl('span', {
            innerHTML: theaterSVG,
            className: 'vjs-icon vjs-icon--theater',
        }, {
            'aria-hidden': 'true'
        }));

        return el;
    }

    buildCSSClass() {
        return `as-theater-control ${super.buildCSSClass()}`;
    }

    handleClick() {
        this.player_.trigger(THEATER_MODE_EVENT, { status: !this.status_() });
    }

    status_() {
        return this.player_.getAttribute(THEATER_MODE_ATTRIBUTE) === 'on';
    }

    update() {
        const status = this.status_();
        const text = `Theater Mode ${status ? 'ON' : 'OFF'}`;

        if (this.controlText() !== text) {
            this.controlText(text);
        }
    }
}

ASTheaterToggle.prototype.controlText_ = 'Theater Mode';

VideoJS.registerComponent(Controls.THEATER_TOGGLE, ASTheaterToggle);

export default ASTheaterToggle;



// WEBPACK FOOTER //
// ./src/player/components/ASTheaterToggle.js